export default __webpack_public_path__ + "static/media/Partner_tools.ac353585.svg";